<template>
  <div>
    <lk-modal v-model="status"
      :footer-hide='true'
      :closable='false'
      :mask-closable='false'
      width="430"
      title="提示"
    >
    <div class="container">
      <div class="content">
        <div class="content_title">
          <span
            :class="{
              'iconfont':true,
              'icon': true,
              'success':type==='success',
              'alert':type==='alert'
            }">{{type==='success'
              ? '&#xe631;'
              : '&#xe613;'
              }}</span>
            <span class="content_title_txt">{{content_title}}</span>
        </div>
          <div class="content_txt">{{content}}</div>
      </div>
      <span class="btns_closetxt" v-if="showCountDown">{{second}}秒后自动关闭</span>
      <div class="btns">
        <lk-button type='primary' @click="confirm">{{confirmText}}</lk-button>
        <lk-button @click="cancel" v-if="!noCancel" class="cancel">{{cancelText}}</lk-button>
      </div>
    </div>
    </lk-modal>
  </div>
</template>
<script>
export default {
  name: 'POSModal',
  props: {
    showCountDown: {
      type: Boolean,
      default: false,
    },
    noCancel: {
      type: Boolean,
      default: false,
    },
    status: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
      default: '',
    },
    content_title: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'alert',
    },
    confirmText: {
      type: String,
      default: '确定',
    },
    cancelText: {
      type: String,
      default: '取消',
    },
  },
  model: {
    prop: 'status',
    event: 'click',
  },
  data() {
    return {
      second: 3,
      time: '',
    };
  },
  watch: {
  },
  methods: {
    cancel() {
      this.$emit('click', false);
      this.$nextTick(() => {
        this.$emit('handleCancel');
      });
    },
    confirm() {
      this.stop();
    },
    countDown() {
      this.second = 3;
      this.time = setInterval(() => {
        this.second--;
        if (this.second === 0) {
          this.stop();
        }
      }, 1000);
    },
    stop() {
      if (this.time) {
        clearInterval(this.time);
      }
      setTimeout(() => {
        this.$emit('click', false);
        this.$nextTick(() => {
          this.$emit('confirm');
        });
      }, 500);
    },
  },
  created() {
  },
};
</script>
<style lang="less" scoped>
.container{
  height: 180px;
  position: relative;
  .btns_closetxt {
    position: absolute;
    bottom: 7px;
    right: 80px;
  }
  .btns{
    display: flex;
    justify-content: flex-end;
    position: absolute;
    bottom: 0;
    right: 0;
    width: 136px;
    .cancel{
      margin-left: 16px
    }
  }
  .content{
    padding: 0 33px;
    width: 100%;
    .content_title {
      display: flex;
      align-items: center;
    }
    .icon{
      margin-right: 6px;
      font-size: 20px;
    }
    .success {
      color: rgb(104,182,39);
    }
    .alert{
      color: rgb(252,154,56);
    }
    .content_title_txt{
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 2px;
    }
    .content_txt {
      word-wrap: break-word;
      word-break:break-all;
      padding-left: 25px;
      padding-top: 10px;
    }
  }
}
</style>
